<nav class="background-color rounded mt-3 px-3" aria-label="breadcrumb" (contextmenu)="showDebug($event, debugObject)">
  <ol class="breadcrumb breadcrumb-webshop align-items-center">
    <li *ngIf="autoStart" appBreadcrumbHeaderItem [routerLink]="shopService.getHomeScreenLink()">{{shopService.getHomeScreenName(mainService.ctxMain)}}</li>
    <ng-content></ng-content>
  </ol>
</nav>
